import React from 'react';
import { Modal, Table, ProgressBar } from 'react-bootstrap';

const RiskScoreModal = ({ show, onHide, customer, riskModel }) => {
    if (!customer || !riskModel) return null;

    const { kycScore, txnScore, total, events } = customer.riskBreakdown;
    const { occupations, nationalities } = riskModel.factors;

    const kycFactors = [
        { factor: 'Occupation', value: customer.occupation, score: occupations[customer.occupation] || 0 },
        { factor: 'Nationality', value: customer.nationality, score: nationalities[customer.nationality] || 0 }
    ];

    const scoreVariant = total > 75 ? 'danger' : total > 40 ? 'warning' : 'success';

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Risk Score Drilldown for {customer.fullName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4 className="text-center">Overall Dynamic Score: {total}</h4>
                <ProgressBar now={total} variant={scoreVariant} className="mb-4" />

                <h5>Static KYC Score Breakdown (Total: {kycScore})</h5>
                <Table striped bordered size="sm">
                    <thead><tr><th>Factor Type</th><th>Customer Value</th><th>Risk Points</th></tr></thead>
                    <tbody>
                        {kycFactors.map(f => (
                            <tr key={f.factor}>
                                <td>{f.factor}</td>
                                <td>{f.value}</td>
                                <td>{f.score}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <h5 className="mt-4">Dynamic Transaction Score Breakdown (Total: {txnScore})</h5>
                <p className="text-muted">This score increases based on real-time transaction activity.</p>
                <Table striped bordered size="sm">
                     <thead><tr><th>Event Date</th><th>Description</th><th>Risk Impact</th></tr></thead>
                     <tbody>
                        {events && events.length > 0 ? (
                            events.map((event, index) => (
                                <tr key={index}>
                                    <td>{event.date}</td>
                                    <td>{event.description}</td>
                                    <td>+{event.impact}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="3" className="text-center">No significant risk events recorded.</td></tr>
                        )}
                     </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
};

export default RiskScoreModal;